<!-- 分类编辑表单 -->
<template>
  <div class="yxtbiz-category-tree-form">
    <div v-if="form.nodeId" class="yxtbiz-category-tree-form-span bg-gray-2">
      <yxt-row>
        <yxt-col :span="3" class="yxtbiz-category-tree-form-span-label">
          {{ $t('pc_biz_lbl_creator'.d('创建人')) }}
        </yxt-col>
        <yxt-col :span="21">
          <div>{{ form.createdBy }}</div>
        </yxt-col>
      </yxt-row>
      <yxt-row>
        <yxt-col :span="3" class="yxtbiz-category-tree-form-span-label">
          {{ $t('pc_biz_lbl_createtime').d('创建时间') }}
        </yxt-col>
        <yxt-col :span="21">
          <div>{{ form.createdAt }}</div>
        </yxt-col>
      </yxt-row>
    </div>
    <yxt-form
      v-if="show"
      :model="form"
      :rules="rule"
      label-position="top"
      label-width="100px"
      ref="form"
    >
      <yxt-form-item
        :label="$t('pc_biz_cate_parent').d('所属分类')"
        prop="pnodeId"
        v-if="form.nodeId !== '1'"
      >
        <yxtbiz-category-selector
          style="width: 100%;"
          :code="code"
          :apiName="apiName"
          v-model="pnode"
          :navCode="navCode"
          :dataPermissionCode="dataPermissionCode"
          @change="change"
        ></yxtbiz-category-selector>
      </yxt-form-item>
      <yxt-form-item :label="$t('pc_biz_cate_name').d('分类名称')" prop="name">
        <yxt-input
          v-model="form.name"
          :maxlength="100"
          show-word-limit
          :placeholder="$t('pc_biz_core_tip_placeholder').d('请输入')"
        ></yxt-input>
      </yxt-form-item>
      <yxt-form-item
        :label="$t('pc_biz_cate_des').d('分类描述')"
        v-if="showDes"
      >
        <yxt-input
          :placeholder="$t('pc_biz_core_tip_placeholder').d('请输入')"
          v-model="form.description"
          type="textarea"
          :maxlength="200"
          show-word-limit
        ></yxt-input>
      </yxt-form-item>
    </yxt-form>
  </div>
</template>

<script>
import { i18n } from 'yxt-biz-pc/packages/common-util/changeLangs';
export default {
  data() {
    return {
      pnode: {
        nodeId: '',
        nodeName: ''
      },
      temp: '',
      form: {
        orgId: localStorage.getItem('orgId'),
        treeId: '',
        pnodeId: '',
        nodeId: '',
        createdBy: '',
        name: '',
        description: '',
        createdAt: ''
      },
      rule: {
        pnodeId: [
          {
            required: true,
            message: i18n.t('biz_pc_cate_parent_required').d('请选择所属分类'),
            trigger: 'blur'
          }
        ],
        name: [
          {
            required: true,
            message: i18n.t('biz_pc_cate_name_required').d('请输入分类名称'),
            trigger: 'blur'
          }
        ]
      }
    };
  },

  props: {
    code: {
      type: String,
      required: true
    },
    navCode: {
      type: String
    },
    dataPermissionCode: {
      type: String
    },
    showDes: {
      type: Boolean,
      default: true
    },
    apiName: {
      type: String,
      default: 'dmp'
    }
  },

  computed: {
    isChanged() {
      return this.temp !== this.getTemp();
    }
  },
  created() {
    // this.init();
  },
  methods: {
    reset() {
      this.form = {
        orgId: localStorage.getItem('orgId'),
        treeId: '',
        pnodeId: '',
        nodeId: '',
        createdBy: '',
        name: '',
        description: '',
        createdAt: '',
        pnodeName: ''
      };
    },
    show(data) {
      this.pnode = {
        nodeId: data.pnodeId,
        nodeName: data.pnodeName
      };
      this.form = Object.assign({}, data);
      this.temp = this.getTemp();
    },
    getTemp() {
      return (
        this.form.nodeId +
        '_' +
        this.form.pnodeId +
        '_' +
        this.form.name +
        '_' +
        this.form.description
      );
    },
    validate() {
      return this.$refs.form.validate();
    },
    change(v) {
      this.form.pnodeId = v.nodeId;
      this.form.pnodeName = v.nodeName;
    }
  }
};
</script>
